// UC30-04, CF-08/CF-30: a site's code is the MPass organisation code, the
// Registrar's IDNO followed by four digits of the unit. The form fixes the IDNO
// and asks for the four digits; what a person types or pastes in that box is
// read here, so a longer entry is never cut to its first four digits.
// per docs/shape-uc-30-sites.md §2
export const BRANCH_SUFFIX_LENGTH = 4;

// A ceiling on what the box keeps, so a pasted paragraph of digits cannot
// grow without bound. It is far above any code (13 + 4 = 17).
const MAX_ENTRY_LENGTH = 32;

/**
 * What the suffix box holds after an edit.
 *
 * - Digits only; the rest is dropped.
 * - The full form `{IDNO}NNNN` of the Registrar being created for is accepted:
 *   the four digits after the IDNO are the suffix.
 * - Any other entry longer than four digits is kept as typed, so the form can
 *   refuse it with a message instead of silently rewriting it.
 */
export function readSuffixInput(raw: string, registrarIdno: string): string {
  const digits = raw.replace(/\D/g, '').slice(0, MAX_ENTRY_LENGTH);
  if (
    registrarIdno &&
    digits.length === registrarIdno.length + BRANCH_SUFFIX_LENGTH &&
    digits.startsWith(registrarIdno)
  ) {
    return digits.slice(registrarIdno.length);
  }
  return digits;
}

export type SuffixProblem = 'required' | 'length' | 'full_code_prefix' | null;

/**
 * Why the box cannot be saved, or null. An entry that is the length of a whole
 * code but does not start with the Registrar's IDNO names the IDNO rule; every
 * other wrong length is the four-digit rule.
 */
export function suffixProblem(suffix: string, registrarIdno: string): SuffixProblem {
  if (!suffix) return 'required';
  if (suffix.length === BRANCH_SUFFIX_LENGTH) return null;
  if (registrarIdno && suffix.length === registrarIdno.length + BRANCH_SUFFIX_LENGTH) {
    return 'full_code_prefix';
  }
  return 'length';
}
